import axios, { AxiosRequestConfig } from 'axios';
import Config from 'servicesCommon/config';
import { userManager } from 'servicesCommon/userManager';

export const gsClient = axios.create({
	baseURL: Config.gsApiBaseUrl,
	headers: Config.headers,
});

export const providerClient = axios.create({
	baseURL: Config.providerApiBaseUrl,
	headers: Config.headers,
});

export const clientClient = axios.create({
	baseURL: Config.clientApiBaseUrl,
	headers: Config.headers,
});

export const personalDataClient = axios.create({
	baseURL: Config.personalDataApiBaseUrl,
	headers: Config.headers,
});

const addToken = (config: AxiosRequestConfig) => {
	return new Promise<AxiosRequestConfig>(resolve => {
		userManager.getUser().then(auth => {
			if (auth) {
				config.headers.Authorization = `Bearer ${auth.access_token}`;
			}
			resolve(config);
		});
	});
};

gsClient.interceptors.request.use(addToken);
providerClient.interceptors.request.use(addToken);
clientClient.interceptors.request.use(addToken);
personalDataClient.interceptors.request.use(addToken);

// tslint:disable-next-line
// const mockifier = require('../api/mockifier').default;
// mockifier(client);
